import React from 'react';

type ChartTodayMarkerProps = {
  x: number | null;
  height: number;
};

/** Amber vertical bar marking the current day (or current week on weekly charts). */
const ChartTodayMarker: React.FC<ChartTodayMarkerProps> = ({ x, height }) => {
  if (x == null) return null;

  return (
    <line
      x1={x}
      y1={0}
      x2={x}
      y2={height}
      stroke="rgb(245 158 11)"
      strokeWidth="1.5"
      strokeOpacity="0.92"
      vectorEffect="non-scaling-stroke"
    />
  );
};

export default ChartTodayMarker;
